import React from 'react';
import PropTypes from 'prop-types';


//components:
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip, Fade } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    chkControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 20px',
        minWidth: 100,
        height: 72,
        width: 100,
    },
    descrControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 270,
        height: 72,
        width: 270,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    inputImporte: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class MoreDetailsCentro extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            telfCentro: '',
            mobilCentro: '',
            gerente: '',
            aforo: '',
            alias: '',
            ctaDescuadre: '',
            ctaFondo: '',
            ctaTotalsemanal: '',
            emailCentro: '',
            esCasino: false,
            esCentral: 0,
            fondoEuros: 0,
            fondoTokens: 0,
            iAreaGeografica: 0,
            numPistas: 0,
            pais: '',
            periodicidad: 0,
            propio: 0,
            tienePartidas: 0,
            sigfrid: -1,
            tecbrain: -1,
            idCc: -1,
            nombrePublicoCc: '',
            nombrePrivadoCc: '',
            iProvincia: -1,
            activoCc: 0,
        };
    };

    componentDidMount() {

        this.setState({
            telfCentro: this.props.centroDetalle.telfCentro || '',
            mobilCentro: this.props.centroDetalle.mobilCentro || '',
            gerente: this.props.centroDetalle.gerente || '',
            aforo: this.props.centroDetalle.aforo || '',
            alias: this.props.centroDetalle.alias || '',
            ctaDescuadre: this.props.centroDetalle.ctaDescuadre || '',
            ctaFondo: this.props.centroDetalle.ctaFondo || '',
            ctaTotalsemanal: this.props.centroDetalle.ctaTotalsemanal || '',
            emailCentro: this.props.centroDetalle.emailCentro || '',
            esCasino: this.props.centroDetalle.esCasino || false, //check
            esCentral: this.props.centroDetalle.esCentral || 0, //check
            fondoEuros: this.props.centroDetalle.fondoEuros || 0,
            fondoTokens: this.props.centroDetalle.fondoTokens || 0,
            iAreaGeografica: this.props.centroDetalle.iAreaGeografica || 0,
            numPistas: this.props.centroDetalle.numPistas || 0,
            pais: this.props.centroDetalle.pais || '',
            periodicidad: this.props.centroDetalle.periodicidad || 0,
            propio: this.props.centroDetalle.propio || 0, //check
            tienePartidas: this.props.centroDetalle.tienePartidas || 0, //check
            sigfrid: this.props.centroDetalle.sigfrid || '',
            tecbrain: this.props.centroDetalle.tecbrain || '',
            idCc: this.props.centroDetalle.idCc || '',
            nombrePublicoCc: this.props.centroDetalle.nombrePublicoCc || '',
            nombrePrivadoCc: this.props.centroDetalle.nombrePrivadoCc || '',
            iProvincia: this.props.centroDetalle.iProvincia || '',
            activoCc: this.props.centroDetalle.activoCc || '', //check
            reopa: this.props.centroDetalle.reopa || ''
        });

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleCheckboxNumber = (e, field) => {
        const value = e.target.checked;

        this.setState({ ...this.state, [field]: value ? 1 : 0 });
    };

    handleCheckboxBool = (e, field) => {
        const value = e.target.checked;

        this.setState({ ...this.state, [field]: value });
    };


    updateHandler = (centro) => {

        if (this.props.checkMoreDetailsDialog(centro)) {
            this.props.modifyFieldsCentroDialog(centro);
            this.props.hideDialog();
        }
    };

    compareDescr = (a, b) => {
        // ignora acentos
        var a_norm = a.descr.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        var b_norm = b.descr.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if (a_norm < b_norm)
            return -1;
        if (a_norm > b_norm)
            return 1;
        return 0;
    }

    fillSelectOptionList = () => {

        return this.props.provinciaList.sort(this.compareDescr).map(tf => {
            return (
                <option key={tf.id} value={tf.id}>{tf.descr}</option>
            );
        });

    };

    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iProvincia: value,
            // provinciaDescr: this.props.tipoFichaList.find(tf => tf.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (<div>
            <form className={classes.root} autoComplete="off">

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id='alias'
                            label='Alias'
                            placeholder='Alias'
                            value={this.state.alias}
                            onChange={(event) => this.handleValueChange(event, 'alias')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='telfCentro'
                            label='Telf Centro'
                            placeholder='Telf Centro'
                            autoFocus
                            value={this.state.telfCentro}
                            onChange={(event) => this.handleValueChange(event, 'telfCentro')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='mobilCentro'
                            label='Mobil Centro'
                            placeholder='Mobil Centro'
                            value={this.state.mobilCentro}
                            onChange={(event) => this.handleValueChange(event, 'mobilCentro')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='gerente'
                            label='Gerente'
                            placeholder='Gerente'
                            value={this.state.gerente}
                            onChange={(event) => this.handleValueChange(event, 'gerente')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='emailCentro'
                            label='email Centro'
                            placeholder='email Centro'
                            value={this.state.emailCentro}
                            onChange={(event) => this.handleValueChange(event, 'emailCentro')}
                        />
                    </FormControl>

                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip title="Cuenta corriente del descuadre semanal" TransitionComponent={Fade} placement="top" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id='ctaDescuadre'
                                label='Cta Descuadre'
                                placeholder='Cta Descuadre'
                                value={this.state.ctaDescuadre}
                                onChange={(event) => this.handleValueChange(event, 'ctaDescuadre')}
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip title="Cuenta corriente de la variación del fondo" TransitionComponent={Fade} placement="top" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id='ctaFondo'
                                label='Cta Fondo'
                                placeholder='Cta Fondo'
                                value={this.state.ctaFondo}
                                onChange={(event) => this.handleValueChange(event, 'ctaFondo')}
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip title="Cuenta corriente del total semanal de cajas" TransitionComponent={Fade} placement="top" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id='ctaTotalsemanal'
                                label='Cta Semanal'
                                placeholder='Cta Semanal'
                                value={this.state.ctaTotalsemanal}
                                onChange={(event) => this.handleValueChange(event, 'ctaTotalsemanal')}
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='fondoEuros'
                            label='Fondo Euros'
                            placeholder='Fondo Euros'
                            value={this.state.fondoEuros}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'fondoEuros')}
                        />
                    </FormControl>

                    <Button className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {

                            this.props.openDialog('EditFondo', {
                                centroid: this.props.centroDetalle.id,
                                openDialog: this.props.openDialog,
                                user: this.props.user
                            });

                        }}>
                        Modificar fondo
                    </Button>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='fondoTokens'
                            label='Fondo Tokens'
                            placeholder='Fondo Tokens'
                            value={this.state.fondoTokens}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'fondoTokens')}
                        />
                    </FormControl>


                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id='aforo'
                            label='Aforo'
                            placeholder='Aforo'
                            value={this.state.aforo}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'aforo')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='numPistas'
                            label='Num Pistas'
                            placeholder='Num Pistas'
                            value={this.state.numPistas}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'numPistas')}
                        />
                    </FormControl>

                    <FormControl className={classes.chkControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.tienePartidas ? true : false}
                                    onChange={e => this.handleCheckboxNumber(e, 'tienePartidas')}
                                />
                            }
                            label="Tiene partidas"
                        />
                    </FormControl>

                    <FormControl className={classes.chkControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.propio ? true : false}
                                    onChange={e => this.handleCheckboxNumber(e, 'propio')}
                                />
                            }
                            label="Es Propio"
                        />
                    </FormControl>
                    <FormControl className={classes.chkControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.esCasino ? true : false}
                                    onChange={e => this.handleCheckboxBool(e, 'esCasino')}
                                />
                            }
                            label="Es Casino"
                        />
                    </FormControl>

                    <FormControl className={classes.chkControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.esCentral ? true : false}
                                    onChange={e => this.handleCheckboxNumber(e, 'esCentral')}
                                />
                            }
                            label="Es Central"
                        />
                    </FormControl>

                </div>

                <div className={classes.containerPair}>

                    {/* <FormControl className={classes.formControl}>
                        <TextField
                            id='iProvincia'
                            label='Provincia'
                            placeholder='Provincia'
                            value={this.state.iProvincia}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'iProvincia')}
                        />
                    </FormControl> */}

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="provincia-placeholder">Provincia</InputLabel>
                        <Select
                            native
                            value={this.state.iProvincia}
                            onChange={(event) => this.handleChangeSelect(event)}
                        >
                            {this.fillSelectOptionList()}
                        </Select>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='iAreaGeografica'
                            label='Area Geografica'
                            placeholder='Area Geografica'
                            value={this.state.iAreaGeografica}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'iAreaGeografica')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='pais'
                            label='Pais'
                            placeholder='Pais'
                            value={this.state.pais}
                            onChange={(event) => this.handleValueChange(event, 'pais')}
                        />
                    </FormControl>

                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id='idCc'
                            label='Id de CC'
                            placeholder='idCc'
                            value={this.state.idCc}
                            onChange={(event) => this.handleValueChange(event, 'idCc')}
                        />
                    </FormControl>

                    <FormControl className={classes.chkControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.activoCc ? true : false}
                                    onChange={e => this.handleCheckboxNumber(e, 'activoCc')}
                                />
                            }
                            label="Activo CC"
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='sigfrid'
                            label='Id de sigfrid'
                            placeholder='Sigfrid'
                            value={this.state.sigfrid}
                            onChange={(event) => this.handleValueChange(event, 'sigfrid')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='tecbrain'
                            label='Id de tecbrain'
                            placeholder='Tecbrain'
                            value={this.state.tecbrain}
                            onChange={(event) => this.handleValueChange(event, 'tecbrain')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id='periodicidad'
                            label='Periodicidad'
                            placeholder='Periodicidad'
                            value={this.state.periodicidad}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            onChange={(event) => this.handleValueChange(event, 'periodicidad')}
                        />
                    </FormControl>


                </div>

                <div className={classes.containerPair}>

                    <FormControl className={classes.descrControl}>
                        <TextField
                            id='nombrePublicoCc'
                            label='Nombre Público CC'
                            placeholder='Nombre Público CC'
                            value={this.state.nombrePublicoCc}
                            onChange={(event) => this.handleValueChange(event, 'nombrePublicoCc')}
                        />
                    </FormControl>

                    <FormControl className={classes.descrControl}>
                        <TextField
                            id='nombrePrivadoCc'
                            label='Nombre Privado CC'
                            placeholder='Nombre Privado CC'
                            value={this.state.nombrePrivadoCc}
                            onChange={(event) => this.handleValueChange(event, 'nombrePrivadoCc')}
                        />
                    </FormControl>


                    {this.props.user && (this.props.user.profile.sub === '795' || this.props.user.profile.sub === '16') ? //solo para estos 2 usuarios (nadie más tiene que poder ver esta opción)
                    <FormControl className={classes.formControl}>
                        <TextField
                            id='reopa'
                            label='op'
                            placeholder='codigo'
                            value={this.state.reopa}
                            onChange={(event) => this.handleValueChange(event, 'reopa')}
                        />
                    </FormControl>
                    : ''}

                </div>

            </form>

            <div className={classes.buttonsContainer}>
                <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Atrás</Button>
                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => this.updateHandler(this.state)}>Guardar</Button>
            </div>
        </div>
        );

    };


};

MoreDetailsCentro.propTypes = {
    //props
    centroDetalle: PropTypes.object.isRequired,
    provinciaList: PropTypes.array.isRequired,
    modifyFieldsCentroDialog: PropTypes.func.isRequired,
    checkMoreDetailsDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MoreDetailsCentro);